export const API_URL = 'https://restcountries.com/v2/all';
export const REGIONS = ['Africa', 'Americas', 'Asia', 'Europe', 'Oceania'];
export const PER_PAGE = 10;